/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const PersonOutlinedBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M14 8c0 1.109-.891 2-2 2s-2-.891-2-2 .891-2 2-2 2 .891 2 2Zm2 0c0 2.213-1.787 4-4 4s-4-1.787-4-4 1.787-4 4-4 4 1.787 4 4ZM6 17.78c0-.604.508-1.298 1.797-1.898C9.022 15.312 10.625 15 12 15c1.375 0 2.978.312 4.203.882 1.289.6 1.797 1.294 1.797 1.899V18H6v-.22ZM12 13c-1.625 0-3.522.359-5.047 1.07C5.492 14.75 4 15.945 4 17.78V20h16v-2.22c0-1.834-1.492-3.03-2.953-3.71C15.522 13.358 13.625 13 12 13Z" /></svg>);
const PersonOutlined = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={PersonOutlinedBase} {...rest} ref={ref} />);
export default PersonOutlined;